import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
// import SearchBar from '../components/SearchBar';
import Destinations from '../components/Destinations';
import About from '../components/About';
import TourPackages from '../components/TourPackages';
// import VideoSection from '../components/VideoSection';
// import WhyChooseUs from '../components/WhyChooseUs';
import Testimonials from '../components/Testimonials';
import Contact from '../components/Contact';
import News from '../components/News';
// import InstagramFeed from '../components/InstagramFeed';
import Footer from '../components/Footer';
// import Preloader from '../components/Preloader'
import Offcanvas from '../components/Offcanvas'
import SearchArea from '../components/SearchArea'
import InternationalDestinations from '../components/InternationalDestinations';
import LocalPackages from '../components/LocalPackages';
import SpecialOffers from '../components/SpecialOffers';

function Home() {
  return (
    <>
      

        {/* <Preloader /> */}
        <Offcanvas />
        <SearchArea />
        <Header />
        <Hero />
        <Destinations />
        <InternationalDestinations />
        <LocalPackages />
        <SpecialOffers />
        <About />
        <TourPackages />
        {/* <VideoSection /> */}
        {/* <WhyChooseUs /> */}
        <Testimonials />
        <Contact />
        <News />
        {/* <InstagramFeed /> */}

      <Footer />
    </>
  );
}

export default Home;